import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import {RefDataItem} from '../../../shared/data-objects/ref-data-item';


@Component({
  selector: 'app-ref-data-dropdown',
  templateUrl: './ref-data-dropdown.component.html',
  styleUrls: ['./ref-data-dropdown.component.css']
})
export class RefDataDropdownComponent implements OnInit {
  @Input()
  isReadOnly = false;
  selectedItemId: number|string;
  items: RefDataItem[];

  @Output() selectedItemUpdated = new EventEmitter();

  public get selectedItem(): RefDataItem {
    if (this.items == null) {
      return null;
    }
    for (const i of this.items) {
      if (Number(i.id) === Number(this.selectedItemId)) {
        return i;
      }
    }
    return null;
  }

  public disableControl(v: boolean) {
    this.isReadOnly = v;
  }

  public set selectedItem(theItem: RefDataItem) {
    if (theItem != null) {
      this.selectedItemId = theItem.id;
    }
  }

  public onSelectedItemChange(event: any): void {
    this.selectedItemUpdated.emit(Number(this.selectedItem));
  }

  constructor() {

  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/ref-data-dropdown/ref-data-dropdown.component.ts